import type { ReactNode } from "react";

export const AppProviders = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};
